import { Button, Flex, Grid, Tooltip, useDisclosure } from '@chakra-ui/react'
import { Card, CardBody, CardTitle } from '../../components/Card'
import { CustomLineChart } from '../../containers/Chart'
import { Filters } from './Filters'
import { createContext, useContext, useEffect, useState } from 'react'
import { StatisticsQuery } from 'BrokerTsLib/src/dtos'
import { useGetProductionStatistics } from '../../hooks/useStatistics'
import { Refresh } from '../../icons'
import { IFilterContext } from 'BrokerTsLib/src/context'

const productionGraphFilterContext = createContext<IFilterContext<StatisticsQuery>>({} as IFilterContext<StatisticsQuery>)

export const useProductionGraphFilter = () => {
  const context = useContext(productionGraphFilterContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useProductionGraphFilter must be used within a ProductionGraph!')
  }

  return context
}

function getMonthName(monthNumber: number) {
  const date = new Date(2000, monthNumber - 1)
  return date.toLocaleString('cs-CZ', { month: 'long' })
}

export const ProductionGraph = () => {
  const { isOpen, onToggle } = useDisclosure()

  const { data, mutateAsync: reloadData, isLoading } = useGetProductionStatistics()

  const chartData = data?.data.items?.map(x => {
    return {
      name: getMonthName(x.month) + (x.year != new Date().getFullYear() ? ` (${x.year})` : ''),
      value: x.ammount
    }
  }) ?? []

  const today = new Date()
  const [filter, setFilter] = useState<StatisticsQuery>({
    from: new Date(today).customAddMonths(-6).customSetDay(1),
    to: new Date(today),
    force: false
  })

  useEffect(() => {
    reloadData(filter)
  }, [filter])

  return (
    <productionGraphFilterContext.Provider value={
      {
        loading: isLoading,
        filter: filter,
        updateFilter: f => setFilter({ ...f }),
        reload: () => reloadData(filter)
      }
    }>
      <Card>
        <CardTitle>
          <Flex sx={{ w: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
            Graf produkce
            <Button
              variant="outline"
              colorScheme="gray"
              color="primary.500"
              size="xs"
              onClick={onToggle}
            >
              Filtrovat
            </Button>
          </Flex>

          <Flex justifyContent='flex-end'>
            <Tooltip label='Aktualizovat' openDelay={100}>
              <Button
                variant='link'
                isDisabled={isLoading}
                onClick={() => {
                  reloadData({ ...filter, force: true })
                }}
                title=''
              >
                <Refresh color="white" />
              </Button>
            </Tooltip>
          </Flex>
        </CardTitle>

        <CardBody>
          <Grid sx={{ gap: 12 }}>
            {isOpen && <Filters />}

            <CustomLineChart data={chartData} />
          </Grid>
        </CardBody>
      </Card>
    </productionGraphFilterContext.Provider>
  )
}
